module.exports = [
  {
    "geoid": "22051020101",
    "pctBlack": 3.3,
    "LE": 76.3,
    "medianIncome": 43125
  },
  {
    "geoid": "22051020102",
    "pctBlack": 1,
    "LE": 81.3,
    "medianIncome": 62151
  },
  {
    "geoid": "22051020201",
    "pctBlack": 10.4,
    "LE": 80.2,
    "medianIncome": 54615
  },
  {
    "geoid": "22051020203",
    "pctBlack": 2.2,
    "LE": 82.1,
    "medianIncome": 84826
  },
  {
    "geoid": "22051020301",
    "pctBlack": 3.5,
    "LE": 81.4,
    "medianIncome": 97050
  },
  {
    "geoid": "22051020302",
    "pctBlack": 2.3,
    "LE": 80.7,
    "medianIncome": 82113
  },
  {
    "geoid": "22051020303",
    "pctBlack": 0.1,
    "LE": 80.3,
    "medianIncome": 63354
  },
  {
    "geoid": "22051020400",
    "pctBlack": 0.2,
    "LE": 80.6,
    "medianIncome": 89444
  },
  {
    "geoid": "22051020502",
    "pctBlack": 12.8,
    "LE": 79.2,
    "medianIncome": 36719
  },
  {
    "geoid": "22051020507",
    "pctBlack": 5.3,
    "LE": 79.5,
    "medianIncome": 47679
  },
  {
    "geoid": "22051020508",
    "pctBlack": 17,
    "LE": 80.5,
    "medianIncome": 68735
  },
  {
    "geoid": "22051020511",
    "pctBlack": 14.7,
    "LE": 80.7,
    "medianIncome": 56389
  },
  {
    "geoid": "22051020512",
    "pctBlack": 4.3,
    "LE": 78.6,
    "medianIncome": 65464
  },
  {
    "geoid": "22051020513",
    "pctBlack": 23.1,
    "LE": 79.3,
    "medianIncome": 43514
  },
  {
    "geoid": "22051020514",
    "pctBlack": 0,
    "LE": 82.7,
    "medianIncome": 95956
  },
  {
    "geoid": "22051020515",
    "pctBlack": 13.3,
    "LE": 78.2,
    "medianIncome": 64778
  },
  {
    "geoid": "22051020516",
    "pctBlack": 31.6,
    "LE": 74.9,
    "medianIncome": 40250
  },
  {
    "geoid": "22051020517",
    "pctBlack": 5.1,
    "LE": 79.8,
    "medianIncome": 80597
  },
  {
    "geoid": "22051020600",
    "pctBlack": 83.2,
    "LE": 74.4,
    "medianIncome": 25313
  },
  {
    "geoid": "22051020700",
    "pctBlack": 46.1,
    "LE": 68.8,
    "medianIncome": 25179
  },
  {
    "geoid": "22051021000",
    "pctBlack": 31.6,
    "LE": 75.4,
    "medianIncome": 40490
  },
  {
    "geoid": "22051021100",
    "pctBlack": 8.5,
    "LE": 74.6,
    "medianIncome": 51827
  },
  {
    "geoid": "22051021200",
    "pctBlack": 16.1,
    "LE": 75.5,
    "medianIncome": 28750
  },
  {
    "geoid": "22051021300",
    "pctBlack": 10.2,
    "LE": 77.7,
    "medianIncome": 75709
  },
  {
    "geoid": "22051021400",
    "pctBlack": 4.7,
    "LE": 80.9,
    "medianIncome": 68828
  },
  {
    "geoid": "22051021500",
    "pctBlack": 32.5,
    "LE": 72.6,
    "medianIncome": 27601
  },
  {
    "geoid": "22051021600",
    "pctBlack": 7.5,
    "LE": 78.9,
    "medianIncome": 37902
  },
  {
    "geoid": "22051021700",
    "pctBlack": 8.9,
    "LE": 77,
    "medianIncome": 52422
  },
  {
    "geoid": "22051021801",
    "pctBlack": 7.5,
    "LE": 78.2,
    "medianIncome": 51200
  },
  {
    "geoid": "22051021803",
    "pctBlack": 37.5,
    "LE": 75.9,
    "medianIncome": 25562
  },
  {
    "geoid": "22051021804",
    "pctBlack": 19.9,
    "LE": 74.4,
    "medianIncome": 28711
  },
  {
    "geoid": "22051021900",
    "pctBlack": 16.5,
    "LE": 77.6,
    "medianIncome": 40189
  },
  {
    "geoid": "22051022001",
    "pctBlack": 37.5,
    "LE": 75.8,
    "medianIncome": 36296
  },
  {
    "geoid": "22051022002",
    "pctBlack": 2.9,
    "LE": 80.1,
    "medianIncome": 80511
  },
  {
    "geoid": "22051022101",
    "pctBlack": 0.1,
    "LE": 81.3,
    "medianIncome": 84688
  },
  {
    "geoid": "22051022102",
    "pctBlack": 13.9,
    "LE": 80.9,
    "medianIncome": 43529
  },
  {
    "geoid": "22051022200",
    "pctBlack": 1.4,
    "LE": 74.1,
    "medianIncome": 54844
  },
  {
    "geoid": "22051022301",
    "pctBlack": 0.6,
    "LE": 80.8,
    "medianIncome": 64932
  },
  {
    "geoid": "22051022302",
    "pctBlack": 6.6,
    "LE": 75.7,
    "medianIncome": 38810
  },
  {
    "geoid": "22051022303",
    "pctBlack": 9.4,
    "LE": 78.4,
    "medianIncome": 40694
  },
  {
    "geoid": "22051022400",
    "pctBlack": 1.6,
    "LE": 81.5,
    "medianIncome": 65817
  },
  {
    "geoid": "22051022500",
    "pctBlack": 2.9,
    "LE": 81.5,
    "medianIncome": 53690
  },
  {
    "geoid": "22051022600",
    "pctBlack": 2.2,
    "LE": 82.8,
    "medianIncome": 119792
  },
  {
    "geoid": "22051022700",
    "pctBlack": 0,
    "LE": 81.8,
    "medianIncome": 61250
  },
  {
    "geoid": "22051022800",
    "pctBlack": 0,
    "LE": 78.1,
    "medianIncome": 44984
  },
  {
    "geoid": "22051022900",
    "pctBlack": 6,
    "LE": 75.2,
    "medianIncome": 44357
  },
  {
    "geoid": "22051023001",
    "pctBlack": 2.5,
    "LE": 80.5,
    "medianIncome": 66023
  },
  {
    "geoid": "22051023002",
    "pctBlack": 2.4,
    "LE": 82,
    "medianIncome": 74904
  },
  {
    "geoid": "22051023003",
    "pctBlack": 2.4,
    "LE": 80.8,
    "medianIncome": 66028
  },
  {
    "geoid": "22051023100",
    "pctBlack": 1.1,
    "LE": 79.4,
    "medianIncome": 45119
  },
  {
    "geoid": "22051023200",
    "pctBlack": 3.6,
    "LE": 73.2,
    "medianIncome": 45160
  },
  {
    "geoid": "22051023300",
    "pctBlack": 2.8,
    "LE": 76.5,
    "medianIncome": 53537
  },
  {
    "geoid": "22051023400",
    "pctBlack": 2,
    "LE": 77.8,
    "medianIncome": 58393
  },
  {
    "geoid": "22051023500",
    "pctBlack": 3.3,
    "LE": 76.8,
    "medianIncome": 59746
  },
  {
    "geoid": "22051023600",
    "pctBlack": 15.1,
    "LE": 73.9,
    "medianIncome": 48563
  },
  {
    "geoid": "22051023700",
    "pctBlack": 96.4,
    "LE": 72.4,
    "medianIncome": 24750
  },
  {
    "geoid": "22051023800",
    "pctBlack": 35,
    "LE": 74.4,
    "medianIncome": 43475
  },
  {
    "geoid": "22051023901",
    "pctBlack": 0.4,
    "LE": 77.7,
    "medianIncome": 65046
  },
  {
    "geoid": "22051023902",
    "pctBlack": 2.6,
    "LE": 80.9,
    "medianIncome": 103194
  },
  {
    "geoid": "22051023903",
    "pctBlack": 0.2,
    "LE": 80.4,
    "medianIncome": 75625
  },
  {
    "geoid": "22051023904",
    "pctBlack": 3.9,
    "LE": 80,
    "medianIncome": 58958
  },
  {
    "geoid": "22051024001",
    "pctBlack": 1.2,
    "LE": 77,
    "medianIncome": 66607
  },
  {
    "geoid": "22051024100",
    "pctBlack": 6.9,
    "LE": 76.4,
    "medianIncome": 52500
  },
  {
    "geoid": "22051024201",
    "pctBlack": 9.3,
    "LE": 74.6,
    "medianIncome": 53664
  },
  {
    "geoid": "22051024202",
    "pctBlack": 22.2,
    "LE": 79.2,
    "medianIncome": 55917
  },
  {
    "geoid": "22051024300",
    "pctBlack": 6.7,
    "LE": 78,
    "medianIncome": 50952
  },
  {
    "geoid": "22051024400",
    "pctBlack": 21.5,
    "LE": 75.4,
    "medianIncome": 40203
  },
  {
    "geoid": "22051024500",
    "pctBlack": 1.6,
    "LE": 77.3,
    "medianIncome": 47292
  },
  {
    "geoid": "22051024600",
    "pctBlack": 65.6,
    "LE": 74.1,
    "medianIncome": 31875
  },
  {
    "geoid": "22051024700",
    "pctBlack": 25.6,
    "LE": 70.2,
    "medianIncome": 37813
  },
  {
    "geoid": "22051024800",
    "pctBlack": 0.4,
    "LE": 82.5,
    "medianIncome": 81401
  },
  {
    "geoid": "22051024900",
    "pctBlack": 21.7,
    "LE": 68.8,
    "medianIncome": 45260
  },
  {
    "geoid": "22051025001",
    "pctBlack": 50.6,
    "LE": 74.7,
    "medianIncome": 42046
  },
  {
    "geoid": "22051025002",
    "pctBlack": 26,
    "LE": 73,
    "medianIncome": 50818
  },
  {
    "geoid": "22051025003",
    "pctBlack": 18.8,
    "LE": 75.8,
    "medianIncome": 58816
  },
  {
    "geoid": "22051025102",
    "pctBlack": 22.4,
    "LE": 77.8,
    "medianIncome": 73750
  },
  {
    "geoid": "22051025103",
    "pctBlack": 40.1,
    "LE": 78.1,
    "medianIncome": 47352
  },
  {
    "geoid": "22051025104",
    "pctBlack": 38.8,
    "LE": 77,
    "medianIncome": 58404
  },
  {
    "geoid": "22051025201",
    "pctBlack": 41.3,
    "LE": 73.6,
    "medianIncome": 30479
  },
  {
    "geoid": "22051025202",
    "pctBlack": 33.4,
    "LE": 74.5,
    "medianIncome": 41672
  },
  {
    "geoid": "22051025300",
    "pctBlack": 6.4,
    "LE": 76.8,
    "medianIncome": 45847
  },
  {
    "geoid": "22051025400",
    "pctBlack": 36.3,
    "LE": 74.9,
    "medianIncome": 45814
  },
  {
    "geoid": "22051025500",
    "pctBlack": 53.2,
    "LE": 75.5,
    "medianIncome": 27689
  },
  {
    "geoid": "22051025600",
    "pctBlack": 20.6,
    "LE": 74.3,
    "medianIncome": 33031
  },
  {
    "geoid": "22051025700",
    "pctBlack": 71.1,
    "LE": 69,
    "medianIncome": 22961
  },
  {
    "geoid": "22051025800",
    "pctBlack": 47.9,
    "LE": 70.9,
    "medianIncome": 27614
  },
  {
    "geoid": "22051025900",
    "pctBlack": 39.2,
    "LE": 75.1,
    "medianIncome": 27188
  },
  {
    "geoid": "22051026000",
    "pctBlack": 15.1,
    "LE": 69.3,
    "medianIncome": 35912
  },
  {
    "geoid": "22051026100",
    "pctBlack": 47.6,
    "LE": 71.1,
    "medianIncome": 24967
  },
  {
    "geoid": "22051026300",
    "pctBlack": 10.3,
    "LE": 75.6,
    "medianIncome": 45484
  },
  {
    "geoid": "22051026400",
    "pctBlack": 7,
    "LE": 73.9,
    "medianIncome": 47500
  },
  {
    "geoid": "22051026500",
    "pctBlack": 13.7,
    "LE": 72.3,
    "medianIncome": 25938
  },
  {
    "geoid": "22051026600",
    "pctBlack": 4.5,
    "LE": 71.5,
    "medianIncome": 42788
  },
  {
    "geoid": "22051026700",
    "pctBlack": 30.2,
    "LE": 71.2,
    "medianIncome": 34808
  },
  {
    "geoid": "22051026800",
    "pctBlack": 77.4,
    "LE": 68,
    "medianIncome": 20208
  },
  {
    "geoid": "22051026900",
    "pctBlack": 93.2,
    "LE": 72.2,
    "medianIncome": 21519
  },
  {
    "geoid": "22051027000",
    "pctBlack": 36.2,
    "LE": 71.9,
    "medianIncome": 35297
  },
  {
    "geoid": "22051027100",
    "pctBlack": 16.2,
    "LE": 72.7,
    "medianIncome": 41979
  },
  {
    "geoid": "22051027200",
    "pctBlack": 27.1,
    "LE": 72.1,
    "medianIncome": 30581
  },
  {
    "geoid": "22051027501",
    "pctBlack": 58.3,
    "LE": 73.8,
    "medianIncome": 45653
  },
  {
    "geoid": "22051027502",
    "pctBlack": 99.7,
    "LE": 73.1,
    "medianIncome": 30769
  },
  {
    "geoid": "22051027601",
    "pctBlack": 34.1,
    "LE": 73,
    "medianIncome": 30496
  },
  {
    "geoid": "22051027602",
    "pctBlack": 63.3,
    "LE": 72.6,
    "medianIncome": 27938
  },
  {
    "geoid": "22051027701",
    "pctBlack": 95.4,
    "LE": 73.1,
    "medianIncome": 26709
  },
  {
    "geoid": "22051027703",
    "pctBlack": 55,
    "LE": 71.9,
    "medianIncome": 32023
  },
  {
    "geoid": "22051027803",
    "pctBlack": 52.7,
    "LE": 72.3,
    "medianIncome": 28357
  },
  {
    "geoid": "22051027804",
    "pctBlack": 42.6,
    "LE": 77.7,
    "medianIncome": 97083
  },
  {
    "geoid": "22051027805",
    "pctBlack": 52.5,
    "LE": 78.2,
    "medianIncome": 61979
  },
  {
    "geoid": "22051027806",
    "pctBlack": 12.4,
    "LE": 78.5,
    "medianIncome": 54707
  },
  {
    "geoid": "22051027807",
    "pctBlack": 22.7,
    "LE": 79.3,
    "medianIncome": 74538
  },
  {
    "geoid": "22051027809",
    "pctBlack": 28,
    "LE": 76.9,
    "medianIncome": 45392
  },
  {
    "geoid": "22051027811",
    "pctBlack": 81.5,
    "LE": 75.5,
    "medianIncome": 53500
  },
  {
    "geoid": "22051027812",
    "pctBlack": 86.7,
    "LE": 70.8,
    "medianIncome": 34850
  },
  {
    "geoid": "22051027901",
    "pctBlack": 0.7,
    "LE": 75.3,
    "medianIncome": 43269
  },
  {
    "geoid": "22051027902",
    "pctBlack": 0.1,
    "LE": 73.8,
    "medianIncome": 42880
  },
  {
    "geoid": "22051028000",
    "pctBlack": 19.8,
    "LE": 76,
    "medianIncome": 62354
  },
  {
    "geoid": "22051028100",
    "pctBlack": 86.3,
    "LE": 71.8,
    "medianIncome": 22696
  },
  {
    "geoid": "22051028200",
    "pctBlack": 39,
    "LE": 72.2,
    "medianIncome": 31925
  },
  {
    "geoid": "22071000100",
    "pctBlack": 14.7,
    "LE": 78.4,
    "medianIncome": 49789
  },
  {
    "geoid": "22071000200",
    "pctBlack": 83.8,
    "LE": 73.5,
    "medianIncome": 28000
  },
  {
    "geoid": "22071000300",
    "pctBlack": 88.7,
    "LE": 71.3,
    "medianIncome": 23750
  },
  {
    "geoid": "22071000400",
    "pctBlack": 83.1,
    "LE": 75.6,
    "medianIncome": 30165
  },
  {
    "geoid": "22071000601",
    "pctBlack": 99.1,
    "LE": 71.3,
    "medianIncome": 12228
  },
  {
    "geoid": "22071000602",
    "pctBlack": 87,
    "LE": 77.5,
    "medianIncome": 30825
  },
  {
    "geoid": "22071000603",
    "pctBlack": 87.2,
    "LE": 72.9,
    "medianIncome": 15893
  },
  {
    "geoid": "22071000604",
    "pctBlack": 80.4,
    "LE": 73.2,
    "medianIncome": 26798
  },
  {
    "geoid": "22071000605",
    "pctBlack": 67.5,
    "LE": 70.3,
    "medianIncome": 35268
  },
  {
    "geoid": "22071000606",
    "pctBlack": 54,
    "LE": 75.8,
    "medianIncome": 59849
  },
  {
    "geoid": "22071000607",
    "pctBlack": 52,
    "LE": 80.8,
    "medianIncome": 65284
  },
  {
    "geoid": "22071000611",
    "pctBlack": 81.8,
    "LE": 74.7,
    "medianIncome": 37197
  },
  {
    "geoid": "22071000612",
    "pctBlack": 33.3,
    "LE": 80.8,
    "medianIncome": 161250
  },
  {
    "geoid": "22071000613",
    "pctBlack": 87.8,
    "LE": 72.9,
    "medianIncome": 16532
  },
  {
    "geoid": "22071000615",
    "pctBlack": 67.7,
    "LE": 79.3,
    "medianIncome": 33514
  },
  {
    "geoid": "22071000616",
    "pctBlack": 54.7,
    "LE": 75.3,
    "medianIncome": 53287
  },
  {
    "geoid": "22071000617",
    "pctBlack": 83.3,
    "LE": 73.7,
    "medianIncome": 31993
  },
  {
    "geoid": "22071000618",
    "pctBlack": 55.8,
    "LE": 82.2,
    "medianIncome": 101955
  },
  {
    "geoid": "22071000702",
    "pctBlack": 81.5,
    "LE": 73.1,
    "medianIncome": 24943
  },
  {
    "geoid": "22071000800",
    "pctBlack": 86.3,
    "LE": 71.7,
    "medianIncome": 22500
  },
  {
    "geoid": "22071000904",
    "pctBlack": 91.5,
    "LE": 66.6,
    "medianIncome": 19235
  },
  {
    "geoid": "22071001100",
    "pctBlack": 42.8,
    "LE": 72.1,
    "medianIncome": 34375
  },
  {
    "geoid": "22071001200",
    "pctBlack": 13.8,
    "LE": 71.4,
    "medianIncome": 44911
  },
  {
    "geoid": "22071001301",
    "pctBlack": 74.7,
    "LE": 68.1,
    "medianIncome": 20707
  },
  {
    "geoid": "22071001302",
    "pctBlack": 90.6,
    "LE": 62.6,
    "medianIncome": 13393
  },
  {
    "geoid": "22071001401",
    "pctBlack": 93.6,
    "LE": 71.3,
    "medianIncome": 18357
  },
  {
    "geoid": "22071001402",
    "pctBlack": 87.6,
    "LE": 68.7,
    "medianIncome": 23802
  },
  {
    "geoid": "22071001500",
    "pctBlack": 80.5,
    "LE": 72.5,
    "medianIncome": 22176
  },
  {
    "geoid": "22071001701",
    "pctBlack": 93.7,
    "LE": 78.4,
    "medianIncome": 38073
  },
  {
    "geoid": "22071001702",
    "pctBlack": 75.9,
    "LE": 75.5,
    "medianIncome": 39722
  },
  {
    "geoid": "22071001720",
    "pctBlack": 91.7,
    "LE": 71.4,
    "medianIncome": 24301
  },
  {
    "geoid": "22071001722",
    "pctBlack": 92.8,
    "LE": 73.4,
    "medianIncome": 27299
  },
  {
    "geoid": "22071001723",
    "pctBlack": 93.8,
    "LE": 78.1,
    "medianIncome": 29291
  },
  {
    "geoid": "22071001724",
    "pctBlack": 91.5,
    "LE": 68.8,
    "medianIncome": 23731
  },
  {
    "geoid": "22071001725",
    "pctBlack": 91.9,
    "LE": 77.2,
    "medianIncome": 29761
  },
  {
    "geoid": "22071001735",
    "pctBlack": 93,
    "LE": 72.7,
    "medianIncome": 24028
  },
  {
    "geoid": "22071001737",
    "pctBlack": 94.4,
    "LE": 75.3,
    "medianIncome": 25324
  },
  {
    "geoid": "22071001739",
    "pctBlack": 98.8,
    "LE": 75.7,
    "medianIncome": 37905
  },
  {
    "geoid": "22071001740",
    "pctBlack": 98.3,
    "LE": 76.6,
    "medianIncome": 33613
  },
  {
    "geoid": "22071001741",
    "pctBlack": 59.7,
    "LE": 72,
    "medianIncome": 41776
  },
  {
    "geoid": "22071001743",
    "pctBlack": 96.3,
    "LE": 72.1,
    "medianIncome": 21896
  },
  {
    "geoid": "22071001744",
    "pctBlack": 97.8,
    "LE": 71.7,
    "medianIncome": 18114
  },
  {
    "geoid": "22071001745",
    "pctBlack": 93.7,
    "LE": 73.8,
    "medianIncome": 22110
  },
  {
    "geoid": "22071001746",
    "pctBlack": 98.1,
    "LE": 69.5,
    "medianIncome": 31894
  },
  {
    "geoid": "22071001747",
    "pctBlack": 74.9,
    "LE": 82.4,
    "medianIncome": 78315
  },
  {
    "geoid": "22071001748",
    "pctBlack": 86.1,
    "LE": 76.8,
    "medianIncome": 41224
  },
  {
    "geoid": "22071001749",
    "pctBlack": 35.9,
    "LE": 78.4,
    "medianIncome": 35345
  },
  {
    "geoid": "22071001750",
    "pctBlack": 29,
    "LE": 75.9,
    "medianIncome": 28508
  },
  {
    "geoid": "22071001751",
    "pctBlack": 60.6,
    "LE": 74.1,
    "medianIncome": 16842
  },
  {
    "geoid": "22071001900",
    "pctBlack": 63.7,
    "LE": 72.9,
    "medianIncome": 25964
  },
  {
    "geoid": "22071002000",
    "pctBlack": 85.4,
    "LE": 65.3,
    "medianIncome": 20682
  },
  {
    "geoid": "22071002200",
    "pctBlack": 90.8,
    "LE": 71.7,
    "medianIncome": 20216
  },
  {
    "geoid": "22071002300",
    "pctBlack": 94,
    "LE": 70.8,
    "medianIncome": 23862
  },
  {
    "geoid": "22071002401",
    "pctBlack": 81,
    "LE": 78.5,
    "medianIncome": 40159
  },
  {
    "geoid": "22071002402",
    "pctBlack": 89.1,
    "LE": 72.5,
    "medianIncome": 28250
  },
  {
    "geoid": "22071002501",
    "pctBlack": 87,
    "LE": 75.5,
    "medianIncome": 37083
  },
  {
    "geoid": "22071002502",
    "pctBlack": 93.4,
    "LE": 73.1,
    "medianIncome": 29574
  },
  {
    "geoid": "22071002503",
    "pctBlack": 62.5,
    "LE": 78.1,
    "medianIncome": 48421
  },
  {
    "geoid": "22071002504",
    "pctBlack": 71.2,
    "LE": 76.4,
    "medianIncome": 46361
  },
  {
    "geoid": "22071002600",
    "pctBlack": 7.7,
    "LE": 80.1,
    "medianIncome": 44063
  },
  {
    "geoid": "22071002700",
    "pctBlack": 81.5,
    "LE": 65.6,
    "medianIncome": 21829
  },
  {
    "geoid": "22071002800",
    "pctBlack": 96.8,
    "LE": 68.3,
    "medianIncome": 23516
  },
  {
    "geoid": "22071002900",
    "pctBlack": 92.3,
    "LE": 64.8,
    "medianIncome": 22045
  },
  {
    "geoid": "22071003000",
    "pctBlack": 89.8,
    "LE": 68.4,
    "medianIncome": 14671
  },
  {
    "geoid": "22071003100",
    "pctBlack": 88.9,
    "LE": 68.5,
    "medianIncome": 17123
  },
  {
    "geoid": "22071003301",
    "pctBlack": 46.9,
    "LE": 73.6,
    "medianIncome": 60114
  },
  {
    "geoid": "22071003302",
    "pctBlack": 87.2,
    "LE": 79.9,
    "medianIncome": 54038
  },
  {
    "geoid": "22071003303",
    "pctBlack": 66.1,
    "LE": 75.4,
    "medianIncome": 29792
  },
  {
    "geoid": "22071003308",
    "pctBlack": 90.1,
    "LE": 73.5,
    "medianIncome": 26297
  },
  {
    "geoid": "22071003400",
    "pctBlack": 68.5,
    "LE": 73.5,
    "medianIncome": 21991
  },
  {
    "geoid": "22071003500",
    "pctBlack": 84.9,
    "LE": 68.9,
    "medianIncome": 20714
  },
  {
    "geoid": "22071003600",
    "pctBlack": 81.7,
    "LE": 70.9,
    "medianIncome": 25712
  },
  {
    "geoid": "22071003702",
    "pctBlack": 65.1,
    "LE": 81.9,
    "medianIncome": 29657
  },
  {
    "geoid": "22071003800",
    "pctBlack": 1.9,
    "LE": 78.5,
    "medianIncome": 77804
  },
  {
    "geoid": "22071003900",
    "pctBlack": 50.2,
    "LE": 74.5,
    "medianIncome": 28594
  },
  {
    "geoid": "22071004000",
    "pctBlack": 66.7,
    "LE": 77,
    "medianIncome": 25389
  },
  {
    "geoid": "22071004100",
    "pctBlack": 12.9,
    "LE": 80.1,
    "medianIncome": 54531
  },
  {
    "geoid": "22071004401",
    "pctBlack": 81.5,
    "LE": 66.4,
    "medianIncome": 17212
  },
  {
    "geoid": "22071004500",
    "pctBlack": 60.6,
    "LE": 72.9,
    "medianIncome": 29853
  },
  {
    "geoid": "22071004600",
    "pctBlack": 6.1,
    "LE": 79.9,
    "medianIncome": 51458
  },
  {
    "geoid": "22071004900",
    "pctBlack": 63.6,
    "LE": 71.8,
    "medianIncome": 15466
  },
  {
    "geoid": "22071005400",
    "pctBlack": 17.6,
    "LE": 78.8,
    "medianIncome": 39573
  },
  {
    "geoid": "22071005500",
    "pctBlack": 5.4,
    "LE": 84.2,
    "medianIncome": 60662
  },
  {
    "geoid": "22071005601",
    "pctBlack": 2.7,
    "LE": 83.2,
    "medianIncome": 79886
  },
  {
    "geoid": "22071005602",
    "pctBlack": 3.9,
    "LE": 88.1,
    "medianIncome": 95766
  },
  {
    "geoid": "22071005603",
    "pctBlack": 2.7,
    "LE": 79.2,
    "medianIncome": 71833
  },
  {
    "geoid": "22071005604",
    "pctBlack": 3.2,
    "LE": 80.9,
    "medianIncome": 94375
  },
  {
    "geoid": "22071006300",
    "pctBlack": 50.9,
    "LE": 75.9,
    "medianIncome": 20882
  },
  {
    "geoid": "22071006400",
    "pctBlack": 44,
    "LE": 77,
    "medianIncome": 39330
  },
  {
    "geoid": "22071006500",
    "pctBlack": 27.3,
    "LE": 77.6,
    "medianIncome": 37368
  },
  {
    "geoid": "22071006900",
    "pctBlack": 98.3,
    "LE": 67.5,
    "medianIncome": 14483
  },
  {
    "geoid": "22071007101",
    "pctBlack": 71.2,
    "LE": 74.2,
    "medianIncome": 15845
  },
  {
    "geoid": "22071007200",
    "pctBlack": 82.2,
    "LE": 71.7,
    "medianIncome": 18667
  },
  {
    "geoid": "22071007501",
    "pctBlack": 91,
    "LE": 72.8,
    "medianIncome": 21099
  },
  {
    "geoid": "22071007502",
    "pctBlack": 86.4,
    "LE": 72.1,
    "medianIncome": 19970
  },
  {
    "geoid": "22071007604",
    "pctBlack": 3.2,
    "LE": 80.4,
    "medianIncome": 155714
  },
  {
    "geoid": "22071007605",
    "pctBlack": 83.3,
    "LE": 77.8,
    "medianIncome": 19500
  },
  {
    "geoid": "22071007606",
    "pctBlack": 11.4,
    "LE": 82.7,
    "medianIncome": 71890
  },
  {
    "geoid": "22071007700",
    "pctBlack": 11.1,
    "LE": 80.3,
    "medianIncome": 70521
  },
  {
    "geoid": "22071008200",
    "pctBlack": 13.8,
    "LE": 75.5,
    "medianIncome": 44960
  },
  {
    "geoid": "22071008300",
    "pctBlack": 13.8,
    "LE": 79,
    "medianIncome": 61250
  },
  {
    "geoid": "22071008400",
    "pctBlack": 47.1,
    "LE": 78,
    "medianIncome": 30917
  },
  {
    "geoid": "22071008600",
    "pctBlack": 81.4,
    "LE": 72.9,
    "medianIncome": 16576
  },
  {
    "geoid": "22071008800",
    "pctBlack": 21.5,
    "LE": 75.5,
    "medianIncome": 54000
  },
  {
    "geoid": "22071009000",
    "pctBlack": 1.8,
    "LE": 80.7,
    "medianIncome": 101156
  },
  {
    "geoid": "22071009100",
    "pctBlack": 41,
    "LE": 73.8,
    "medianIncome": 38646
  },
  {
    "geoid": "22071009200",
    "pctBlack": 95.3,
    "LE": 72.1,
    "medianIncome": 13947
  },
  {
    "geoid": "22071009400",
    "pctBlack": 86,
    "LE": 62.3,
    "medianIncome": 11649
  },
  {
    "geoid": "22071009600",
    "pctBlack": 29.7,
    "LE": 74.4,
    "medianIncome": 57083
  },
  {
    "geoid": "22071009700",
    "pctBlack": 42.2,
    "LE": 76.1,
    "medianIncome": 43214
  },
  {
    "geoid": "22071009900",
    "pctBlack": 14,
    "LE": 75.7,
    "medianIncome": 55469
  },
  {
    "geoid": "22071010000",
    "pctBlack": 73.4,
    "LE": 74.3,
    "medianIncome": 23143
  },
  {
    "geoid": "22071010200",
    "pctBlack": 77.5,
    "LE": 71.7,
    "medianIncome": 30688
  },
  {
    "geoid": "22071010300",
    "pctBlack": 82.5,
    "LE": 75.7,
    "medianIncome": 25045
  },
  {
    "geoid": "22071010600",
    "pctBlack": 29.8,
    "LE": 75.3,
    "medianIncome": 47000
  },
  {
    "geoid": "22071010700",
    "pctBlack": 10,
    "LE": 82.1,
    "medianIncome": 68558
  },
  {
    "geoid": "22071010800",
    "pctBlack": 5.8,
    "LE": 81.3,
    "medianIncome": 100878
  },
  {
    "geoid": "22071010900",
    "pctBlack": 40.6,
    "LE": 83.7,
    "medianIncome": 59661
  },
  {
    "geoid": "22071011100",
    "pctBlack": 60.5,
    "LE": 75.4,
    "medianIncome": 36362
  },
  {
    "geoid": "22071011200",
    "pctBlack": 28.3,
    "LE": 79.5,
    "medianIncome": 59878
  },
  {
    "geoid": "22071011400",
    "pctBlack": 1.9,
    "LE": 81,
    "medianIncome": 56104
  },
  {
    "geoid": "22071011500",
    "pctBlack": 6.5,
    "LE": 81.4,
    "medianIncome": 105724
  },
  {
    "geoid": "22071011600",
    "pctBlack": 3.5,
    "LE": 78.7,
    "medianIncome": 151696
  },
  {
    "geoid": "22071011700",
    "pctBlack": 0.4,
    "LE": 80.7,
    "medianIncome": 127826
  },
  {
    "geoid": "22071012000",
    "pctBlack": 4.4,
    "LE": 86.8,
    "medianIncome": 88958
  },
  {
    "geoid": "22071012101",
    "pctBlack": 5.5,
    "LE": 82.8,
    "medianIncome": 54076
  },
  {
    "geoid": "22071012200",
    "pctBlack": 6.5,
    "LE": 80.5,
    "medianIncome": 100091
  },
  {
    "geoid": "22071012300",
    "pctBlack": 35.3,
    "LE": 74.1,
    "medianIncome": 56141
  },
  {
    "geoid": "22071012400",
    "pctBlack": 27.9,
    "LE": 80.1,
    "medianIncome": 61719
  },
  {
    "geoid": "22071012500",
    "pctBlack": 23.8,
    "LE": 77.3,
    "medianIncome": 43333
  },
  {
    "geoid": "22071012600",
    "pctBlack": 6.4,
    "LE": 79.9,
    "medianIncome": 53646
  },
  {
    "geoid": "22071012700",
    "pctBlack": 23.4,
    "LE": 78.2,
    "medianIncome": 55125
  },
  {
    "geoid": "22071012800",
    "pctBlack": 18.3,
    "LE": 74.1,
    "medianIncome": 64034
  },
  {
    "geoid": "22071012900",
    "pctBlack": 31.6,
    "LE": 75.4,
    "medianIncome": 41172
  },
  {
    "geoid": "22071013000",
    "pctBlack": 51.5,
    "LE": 77.2,
    "medianIncome": 38250
  },
  {
    "geoid": "22071013100",
    "pctBlack": 70.7,
    "LE": 73.5,
    "medianIncome": 16789
  },
  {
    "geoid": "22071013301",
    "pctBlack": 4.4,
    "LE": 85.1,
    "medianIncome": 112813
  },
  {
    "geoid": "22071013302",
    "pctBlack": 21.5,
    "LE": 80.4,
    "medianIncome": 95795
  },
  {
    "geoid": "22071013400",
    "pctBlack": 23.5,
    "LE": 78.8,
    "medianIncome": 63015
  },
  {
    "geoid": "22071013600",
    "pctBlack": 49.3,
    "LE": 68.5,
    "medianIncome": 34583
  },
  {
    "geoid": "22071013700",
    "pctBlack": 94.8,
    "LE": 66,
    "medianIncome": 13095
  },
  {
    "geoid": "22071013800",
    "pctBlack": 95.9,
    "LE": 69.9,
    "medianIncome": 20149
  },
  {
    "geoid": "22071013900",
    "pctBlack": 42.7,
    "LE": 81.2,
    "medianIncome": 48333
  },
  {
    "geoid": "22071014000",
    "pctBlack": 92.1,
    "LE": 72.1,
    "medianIncome": 9927
  },
  {
    "geoid": "22071014200",
    "pctBlack": 32.8,
    "LE": 76.7,
    "medianIncome": 49837
  },
  {
    "geoid": "22071014300",
    "pctBlack": 87.8,
    "LE": 69.5,
    "medianIncome": 14458
  },
  {
    "geoid": "22071014400",
    "pctBlack": 36.5,
    "LE": 77.1,
    "medianIncome": 36042
  },
  {
    "geoid": "22075050100",
    "pctBlack": 84,
    "LE": 75.5,
    "medianIncome": 45469
  },
  {
    "geoid": "22075050200",
    "pctBlack": 2.8,
    "LE": 78.4,
    "medianIncome": 60205
  },
  {
    "geoid": "22075050300",
    "pctBlack": 11.1,
    "LE": 77.2,
    "medianIncome": 51111
  },
  {
    "geoid": "22075050500",
    "pctBlack": 56.4,
    "LE": 71.5,
    "medianIncome": 31314
  },
  {
    "geoid": "22075050600",
    "pctBlack": 28.1,
    "LE": 71.1,
    "medianIncome": 26538
  },
  {
    "geoid": "22075050800",
    "pctBlack": 20.7,
    "LE": 72.2,
    "medianIncome": 31000
  },
  {
    "geoid": "22087030103",
    "pctBlack": 21.6,
    "LE": 72.6,
    "medianIncome": 36826
  },
  {
    "geoid": "22087030104",
    "pctBlack": 1.6,
    "LE": 73,
    "medianIncome": 45234
  },
  {
    "geoid": "22087030203",
    "pctBlack": 6.9,
    "LE": 73.5,
    "medianIncome": 36738
  },
  {
    "geoid": "22087030204",
    "pctBlack": 69.5,
    "LE": 71.9,
    "medianIncome": 35221
  },
  {
    "geoid": "22087030206",
    "pctBlack": 9.4,
    "LE": 73,
    "medianIncome": 66094
  },
  {
    "geoid": "22087030207",
    "pctBlack": 10.2,
    "LE": 78.1,
    "medianIncome": 60638
  },
  {
    "geoid": "22087030208",
    "pctBlack": 11.6,
    "LE": 77,
    "medianIncome": 67738
  },
  {
    "geoid": "22087030209",
    "pctBlack": 17.6,
    "LE": 76.9,
    "medianIncome": 65189
  },
  {
    "geoid": "22087030300",
    "pctBlack": 13.2,
    "LE": 76.9,
    "medianIncome": 34750
  },
  {
    "geoid": "22087030400",
    "pctBlack": 12.3,
    "LE": 74.4,
    "medianIncome": 42989
  },
  {
    "geoid": "22087030500",
    "pctBlack": 16.4,
    "LE": 74.9,
    "medianIncome": 42411
  },
  {
    "geoid": "22087030602",
    "pctBlack": 16.1,
    "LE": 74.2,
    "medianIncome": 41579
  },
  {
    "geoid": "22087030700",
    "pctBlack": 15,
    "LE": 75.5,
    "medianIncome": 34788
  },
  {
    "geoid": "22087030800",
    "pctBlack": 18.8,
    "LE": 72.4,
    "medianIncome": 38258
  },
  {
    "geoid": "22089060100",
    "pctBlack": 20.3,
    "LE": 78.1,
    "medianIncome": 72396
  },
  {
    "geoid": "22089062100",
    "pctBlack": 32.3,
    "LE": 79.5,
    "medianIncome": 47583
  },
  {
    "geoid": "22089062301",
    "pctBlack": 24.1,
    "LE": 77.9,
    "medianIncome": 72458
  },
  {
    "geoid": "22089062302",
    "pctBlack": 21.3,
    "LE": 80.6,
    "medianIncome": 62061
  },
  {
    "geoid": "22089062400",
    "pctBlack": 39.3,
    "LE": 72.2,
    "medianIncome": 34278
  },
  {
    "geoid": "22089062500",
    "pctBlack": 6.2,
    "LE": 76.1,
    "medianIncome": 65966
  },
  {
    "geoid": "22089062700",
    "pctBlack": 51.5,
    "LE": 75.3,
    "medianIncome": 46366
  },
  {
    "geoid": "22089062800",
    "pctBlack": 51.2,
    "LE": 72.7,
    "medianIncome": 42679
  },
  {
    "geoid": "22089062900",
    "pctBlack": 10,
    "LE": 76.5,
    "medianIncome": 59313
  },
  {
    "geoid": "22089063000",
    "pctBlack": 42.9,
    "LE": 77.8,
    "medianIncome": 62689
  },
  {
    "geoid": "22089063100",
    "pctBlack": 3.1,
    "LE": 79.8,
    "medianIncome": 88115
  },
  {
    "geoid": "22089063200",
    "pctBlack": 2.2,
    "LE": 75.8,
    "medianIncome": 69970
  },
  {
    "geoid": "22093040100",
    "pctBlack": 39.5,
    "LE": 75,
    "medianIncome": 47123
  },
  {
    "geoid": "22093040200",
    "pctBlack": 40.3,
    "LE": 75.1,
    "medianIncome": 45185
  },
  {
    "geoid": "22093040300",
    "pctBlack": 18,
    "LE": 80.4,
    "medianIncome": 67429
  },
  {
    "geoid": "22093040400",
    "pctBlack": 68.8,
    "LE": 74,
    "medianIncome": 39444
  },
  {
    "geoid": "22093040500",
    "pctBlack": 93.9,
    "LE": 75.1,
    "medianIncome": 30868
  },
  {
    "geoid": "22093040600",
    "pctBlack": 75.7,
    "LE": 77,
    "medianIncome": 47313
  },
  {
    "geoid": "22093040700",
    "pctBlack": 35.2,
    "LE": 79,
    "medianIncome": 57193
  },
  {
    "geoid": "22095070100",
    "pctBlack": 19.6,
    "LE": 81,
    "medianIncome": 82500
  },
  {
    "geoid": "22095070200",
    "pctBlack": 77.4,
    "LE": 73.9,
    "medianIncome": 60598
  },
  {
    "geoid": "22095070300",
    "pctBlack": 32.3,
    "LE": 76.8,
    "medianIncome": 54000
  },
  {
    "geoid": "22095070400",
    "pctBlack": 34,
    "LE": 78.2,
    "medianIncome": 70370
  },
  {
    "geoid": "22095070500",
    "pctBlack": 66.5,
    "LE": 72.1,
    "medianIncome": 47965
  },
  {
    "geoid": "22095070600",
    "pctBlack": 59.3,
    "LE": 75.6,
    "medianIncome": 37120
  },
  {
    "geoid": "22095070700",
    "pctBlack": 31.9,
    "LE": 75.6,
    "medianIncome": 48008
  },
  {
    "geoid": "22095070800",
    "pctBlack": 90.8,
    "LE": 70.7,
    "medianIncome": 37450
  },
  {
    "geoid": "22095070900",
    "pctBlack": 54.8,
    "LE": 73,
    "medianIncome": 32014
  },
  {
    "geoid": "22095071000",
    "pctBlack": 36.1,
    "LE": 72.7,
    "medianIncome": 40069
  },
  {
    "geoid": "22095071100",
    "pctBlack": 87,
    "LE": 75.3,
    "medianIncome": 46420
  },
  {
    "geoid": "22103040102",
    "pctBlack": 3.1,
    "LE": 75.8,
    "medianIncome": 42129
  },
  {
    "geoid": "22103040103",
    "pctBlack": 0,
    "LE": 76.4,
    "medianIncome": 56250
  },
  {
    "geoid": "22103040104",
    "pctBlack": 1.1,
    "LE": 77.6,
    "medianIncome": 61678
  },
  {
    "geoid": "22103040201",
    "pctBlack": 6.1,
    "LE": 78.4,
    "medianIncome": 62237
  },
  {
    "geoid": "22103040202",
    "pctBlack": 1.3,
    "LE": 78.5,
    "medianIncome": 66417
  },
  {
    "geoid": "22103040303",
    "pctBlack": 3.6,
    "LE": 79.3,
    "medianIncome": 71961
  },
  {
    "geoid": "22103040304",
    "pctBlack": 0,
    "LE": 83.6,
    "medianIncome": 121532
  },
  {
    "geoid": "22103040305",
    "pctBlack": 6.1,
    "LE": 80.5,
    "medianIncome": 92000
  },
  {
    "geoid": "22103040400",
    "pctBlack": 2.3,
    "LE": 81.4,
    "medianIncome": 85213
  },
  {
    "geoid": "22103040501",
    "pctBlack": 45.4,
    "LE": 74.1,
    "medianIncome": 31989
  },
  {
    "geoid": "22103040502",
    "pctBlack": 25.2,
    "LE": 77.6,
    "medianIncome": 43482
  },
  {
    "geoid": "22103040601",
    "pctBlack": 0,
    "LE": 78.1,
    "medianIncome": 95000
  },
  {
    "geoid": "22103040602",
    "pctBlack": 0,
    "LE": 78.5,
    "medianIncome": 56842
  },
  {
    "geoid": "22103040604",
    "pctBlack": 4.9,
    "LE": 81.4,
    "medianIncome": 56280
  },
  {
    "geoid": "22103040605",
    "pctBlack": 6.9,
    "LE": 79.2,
    "medianIncome": 67708
  },
  {
    "geoid": "22103040701",
    "pctBlack": 23.9,
    "LE": 78.4,
    "medianIncome": 64015
  },
  {
    "geoid": "22103040705",
    "pctBlack": 15.3,
    "LE": 75.4,
    "medianIncome": 49993
  },
  {
    "geoid": "22103040706",
    "pctBlack": 2.9,
    "LE": 75.7,
    "medianIncome": 49896
  },
  {
    "geoid": "22103040709",
    "pctBlack": 9.6,
    "LE": 76.6,
    "medianIncome": 69355
  },
  {
    "geoid": "22103040710",
    "pctBlack": 11.9,
    "LE": 79.4,
    "medianIncome": 57478
  },
  {
    "geoid": "22103040801",
    "pctBlack": 17.8,
    "LE": 76.7,
    "medianIncome": 46736
  },
  {
    "geoid": "22103040803",
    "pctBlack": 49,
    "LE": 75,
    "medianIncome": 42480
  },
  {
    "geoid": "22103040900",
    "pctBlack": 58.6,
    "LE": 69.5,
    "medianIncome": 33611
  },
  {
    "geoid": "22103041002",
    "pctBlack": 4.4,
    "LE": 77.6,
    "medianIncome": 54023
  },
  {
    "geoid": "22103041003",
    "pctBlack": 12.2,
    "LE": 78.6,
    "medianIncome": 64269
  },
  {
    "geoid": "22103041004",
    "pctBlack": 3.6,
    "LE": 76.7,
    "medianIncome": 61555
  },
  {
    "geoid": "22103041101",
    "pctBlack": 20.3,
    "LE": 75.4,
    "medianIncome": 55847
  },
  {
    "geoid": "22103041102",
    "pctBlack": 26.7,
    "LE": 75.7,
    "medianIncome": 43430
  },
  {
    "geoid": "22103041103",
    "pctBlack": 31.1,
    "LE": 69.8,
    "medianIncome": 30223
  },
  {
    "geoid": "22103041104",
    "pctBlack": 16.3,
    "LE": 75.9,
    "medianIncome": 69762
  },
  {
    "geoid": "22103041202",
    "pctBlack": 24.2,
    "LE": 76.6,
    "medianIncome": 42727
  },
  {
    "geoid": "22103041204",
    "pctBlack": 21.7,
    "LE": 75.8,
    "medianIncome": 45516
  },
  {
    "geoid": "22103041207",
    "pctBlack": 2.8,
    "LE": 78.8,
    "medianIncome": 81563
  },
  {
    "geoid": "22103041208",
    "pctBlack": 0.5,
    "LE": 83,
    "medianIncome": 133810
  },
  {
    "geoid": "22103041209",
    "pctBlack": 2.7,
    "LE": 80.3,
    "medianIncome": 78274
  },
  {
    "geoid": "22103041210",
    "pctBlack": 0.9,
    "LE": 76.9,
    "medianIncome": 67440
  },
  {
    "geoid": "22103041211",
    "pctBlack": 0.2,
    "LE": 78.8,
    "medianIncome": 93839
  },
  {
    "geoid": "22103041300",
    "pctBlack": 7.6,
    "LE": 81.5,
    "medianIncome": 65865
  }
]
